import Blank from "@/layouts/blank.vue";
import SubHireCommitmentList from "@/pages/admin/sub-hire-commitment/SubHireCommitmentList.vue";

const subHireCommitmentRoutes = [
  {
    path: "sub-hire-commitment",
    name: "app-admin-sub-hire-commitment",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/sub-hire-commitment/list",
      },
      {
        path: "list",
        name: "app-admin-sub-hire-commitment-list",
        component: SubHireCommitmentList,
      },
    ],
  },
];

export default subHireCommitmentRoutes;
